<template>
  <div
    v-if="showLoader"
    class="attendance-loader-shell"
  >
    <WfmLoader />
  </div>
  <div
    v-else-if="weeklyReviewLoading"
    class="weekly-review-loader-overlay"
  >
    <WfmLoader />
  </div>
  <div
    class="attendance-view"
    :style="{ visibility: !showLoader ? 'visible' : 'hidden' }"
  >
    <HeaderComponent
      ref="childRef"
      class="month-switcher"
      :current-folder="currentFolder"
      :is-duty-chart="isDutyChart"
      :register-view="registerView"
      :weekly-review-mode="weeklyReviewMode"
      :selected-cells="selectedCells"
      :on-grid-ready="onGridReady"
      :show-in-out-toggle="showInOutTimeToggle"
      :update-filter-values="updateFilterValues"
      :clear-selection="clearSelection"
      :clear-weekly-selection="clearWeeklySelection"
      :approve-weekly-selection="approveSelectedWeeklyRows"
      :reject-weekly-selection="rejectSelectedWeeklyRows"
      :unapprove-weekly-selection="unapproveSelectedWeeklyRows"
      :save-weekly-selection="saveWeeklyReviewSelection"
      :filters-data="gridDataSource"
      :month-change-btn-control="isRenderComplete"
      @update-month-year="updateMonthYear"
      @show-register-view="showRegisterView"
    />
    <div
      class="grid-container"
      @keydown.capture="keyboardCommandsHandler"
    >
      <div v-if="!registerView">
        <div
          v-if="weeklyReviewMode"
          id="weekly-review-grid"
          class="ag-theme-quartz weekly-review-grid"
        >
          <ag-grid-vue
            :style="{width: '100%', height: weeklyGridHeight}"
            class="ag-grid"
            :column-defs="weeklyReviewColumnDefs"
            :row-data="weeklyReviewRows"
            :row-height="weeklyRowHeight"
            :header-height="headerHeight"
            :default-col-def="defaultColDefWeeklyReview"
            :suppress-row-click-selection="true"
            @grid-ready="onWeeklyGridReady"
            @cell-clicked="onWeeklyCellClicked"
            @cell-key-down="onWeeklyCellKeyDown"
          />
        </div>
        <div
          v-show="!weeklyReviewMode"
          id="attendance-grid"
          class="ag-theme-quartz"
        >
          <ag-grid-vue
            :style="{width: '100%', height: gridHeight}"
            class="ag-grid"
            :row-height="rowHeight"
            :header-height="headerHeight"
            :column-defs="columnDefs"
            :default-col-def="defaultColDefAttendance"
            :row-buffer="rowBuffer"
            :row-selection="rowSelection"
            :suppress-row-selection="suppressRowSelection"
            :suppress-row-click-selection="suppressRowClickSelection"
            :stop-editing-when-grid-loses-focus="stopEditingWhenGridLosesFocus"
            :row-model-type="rowModelType"
            :cache-block-size="cacheBlockSize"
            :cache-overflow-size="cacheOverflowSize"
            :max-concurrent-data-source-requests="maxConcurrentDatasourceRequests"
            :infinite-initial-row-count="infiniteInitialRowCount"
            :max-blocks-in-cache="maxBlocksInCache"
            :pinned-bottom-row-data="pinnedBottomRowData"
            :on-cell-key-down="onCellKeyDown"
            :tooltip-mouse-track="true"
            :loading="true"
            :loading-overlay-component="loadingOverlayComponent"
            @grid-ready="onGridReady"
            @cell-clicked="onCellClicked"
          />
        </div>
      </div>
      <div
        v-else
        id="my-grid"
        class="ag-theme-quartz register-ag-grid"
      >
        <ag-grid-vue
          :style="{width: '100%', height: '88vh'}"
          class="ag-grid"
          :row-height="25"
          :header-height="30"
          :column-defs="columnDefs"
          :default-col-def="defaultColDefRegister"
          :row-buffer="rowBuffer"
          :row-selection="rowSelection"
          :suppress-row-selection="suppressRowSelection"
          :suppress-row-click-selection="suppressRowClickSelection"
          :stop-editing-when-grid-loses-focus="stopEditingWhenGridLosesFocus"
          :row-model-type="rowModelType"
          :cache-block-size="cacheBlockSize"
          :cache-overflow-size="cacheOverflowSize"
          :max-concurrent-data-source-requests="maxConcurrentDatasourceRequests"
          :infinite-initial-row-count="infiniteInitialRowCount"
          :max-blocks-in-cache="maxBlocksInCache"
          :pinned-bottom-row-data="pinnedBottomRowData"
          :on-cell-key-down="onCellKeyDown"
          :tooltip-mouse-track="true"
          :loading="true"
          :loading-overlay-component="loadingOverlayComponent"
          :loading-overlay-component-params="loadingOverlayComponentParams"
          @grid-ready="onGridReady"
          @model-updated="onModelUpdated"
          @cell-clicked="onCellClicked"
        />
      </div>
    </div>
    <WfmModal
      v-if="formOpen"
      class="calendar-modal"
      @close="closeCalendar"
    >
      <template #header>
        <div class="d-flex" />
      </template>
      <template #body>
        <div class="m-3 mt-0">
          <!-- eslint-disable vue/no-v-html -->
          <WfmTabsHorizontal
            :key="tabKey"
            :tabs-list="tabsList"
            :selected-index="selectedIndex"
            :custom-class="customTabsClass"
            @add-tab="addTab"
            @del-tab="delTab"
            @change-tab="changeTab"
            @update-keep-alive-state="updateKeepAliveState"
          />
        </div>

        <!--eslint-enable-->
      </template>
    </WfmModal>

    <div class="alert-window">
      <div class="alert-content">
        Selected rows for approval has deficit hours
        <span class="alert-note"> <br>
          <b>Approve:</b> This action will result in salary deductions if the approval request has attendance with deficit hours.<br><br>
          <b>Settle:</b> This action will ignore all deficit hours and there will be no deductions against deficit hours.
          <br><br>
          <b>Missed Punch:</b> If there are Missed Punch in the request then they will first be adjusted against the available paid leaves. Remaining Missed punches will be marked as 'LWP' resulting in salary deduction.</span>      <span id="deficit-hours"><!----></span>
        <div
          class="alert-buttons"
        >
          <button
            @click="isApproveAttendance(true, 'approve')"
          >
            approve
          </button>
          <button
            @click="isApproveAttendance(false, 'settle')"
          >
            settle
          </button>
          <button
            @click="isApproveAttendance(false, 'cancel')"
          >
            cancel
          </button>
        </div>
      </div>
    </div>

    <div v-if="!registerView">
      <HelperList
        grid-view="attendance"
        :helper-list-data="gridDataSource"
        :show-designation="showDesignations"
        :show-site="showSites"
        :select-unapproved="selectUnapproved"
        :hide-unselected="hideUnselected"
        :can-view-weekly-review="canViewWeeklyReview"
        :weekly-review-mode="weeklyReviewMode"
        :selected-week-start="selectedWeekStart"
        :weekly-range-display="weeklyRangeDisplay"
        :week-picker-min-date="weekPickerMinDate"
        :week-picker-max-date="weekPickerMaxDate"
        :can-go-to-previous-week="canGoToPreviousWeek"
        :can-go-to-next-week="canGoToNextWeek"
        :on-weekly-review-mode-toggle="onWeeklyReviewModeToggle"
        :on-weekly-range-change="onWeeklyRangeChange"
        :go-to-previous-week="goToPreviousWeek"
        :go-to-next-week="goToNextWeek"
        :go-to-current-week="goToCurrentWeek"
        :approve-selected-weekly-rows="approveSelectedWeeklyRows"
        :reject-selected-weekly-rows="rejectSelectedWeeklyRows"
        :clear-weekly-selection="clearWeeklySelection"
        :weekly-review-row-count="weeklyReviewRows.length"
      />
    </div>
  </div>
</template>

<script>
import 'ag-grid-community/styles/ag-grid.css';
import { onBeforeMount, ref, watch, computed } from 'vue';
import { useStore } from 'vuex';
import { toast } from 'vue3-toastify';
import { AgGridVue } from 'ag-grid-vue3';
import WfmLoader from '../../common/loader/wfm-loader.vue';
import AttendanceCellRenderer from './grid-components/AttendanceCellRenderer.vue';
import HeaderComponent from '../grid/common-components/HeaderComponent.vue';
import GridHeaderComponent from '../grid/common-components/GridHeaderComponent.vue';
import TotalHoursHeaderComponent from '../grid/common-components/TotalHoursHeaderComponent.vue';
import EmployeeCellEditor from '../grid/common-components/EmployeeCellEditor.vue';
import cellEditor from './grid-components/CellEditor.vue';
import DropdownCellEditor from './grid-components/register-view-components/DropdownCellEditor.vue';
import WorkingTimeEditor from './grid-components/register-view-components/WorkingTimeEditor.vue';
import AttendanceTypeCellRenderer from './grid-components/register-view-components/AttendanceTypeCellRenderer.vue';
import TimeCellEditor from './grid-components/register-view-components/TimeCellEditor.vue';
import EmployeeCellRenderer from '../grid/common-components/EmployeeCellRenderer.vue';
import AttendanceCellDetailsRenderer from '../grid/common-components/AttendanceCellDetailsRenderer.vue';
import PinnedRowRenderer from './grid-components/PinnedRowRenderer.vue';
import TotalHoursCellRenderer from '../grid/common-components/TotalHoursCellRenderer.vue';
import HelperList from '../grid/common-components/HelperList.vue';
import getFolders from '../../composables/getFolders';
import WfmModal from '../../common/wfm-modal.vue';
import WfmTabsHorizontal from '../../common/wfm-tabs-horizontal.vue';
import attendanceGridUtils from '../../composables/attendanceGridUtils';
import allocationGridUtils from '../../composables/allocationGridUtils';

import dataProcessor from '../../composables/attendanceGridDataProcessor';
import calendarUtils from '../../composables/calendarUtils';
import { v4 as uuidv4 } from 'uuid';
import CustomEmployeeColHeader from '../grid/common-components/CustomEmployeeColHeader.vue';
import postData from '../../composables/postData.js'
import getFatRow from '../../composables/fatRowGenerator';
import getProjections from '../../composables/getProjections';
import usePartnersId from '../../composables/usePartnersId.js';
import RegisterToolTip from '../grid/common-components/RegisterToolTip.vue'
export default {
  name: 'AttendanceGrid',
  components: {
    /* eslint-disable vue/no-unused-components */
    WfmLoader,
    HeaderComponent,
    AgGridVue,
    AttendanceCellRenderer,
    cellEditor,
    DropdownCellEditor,
    AttendanceTypeCellRenderer,
    WorkingTimeEditor,
    TimeCellEditor,
    GridHeaderComponent,
    PinnedRowRenderer,
    HelperList,
    WfmModal,
    WfmTabsHorizontal,
    AttendanceCellDetailsRenderer,
    RegisterToolTip,
    /* eslint-enable */
  },
  setup(props) {
    //variables
    // Extract necessary data from the store
    const store = useStore();
    const { getAttendanceDate, txnDataSetter, generateTxn, save, attendancePeriodColumns, getDocpickerList, selectUnapprovedSetter, selectedCellsSetter, attendanceRegisterColumns, approveAttendance, rejectAttendance, unapproveAttendance, convertMinutesToHoursFormat } = attendanceGridUtils();
    const { getAllDocpickerList } = allocationGridUtils();
    const { getFoldersFormList, getCurrentFolder } = getFolders();
    const {projectionForFolder} = getProjections()

    const bSettings = store.getters['bSettings'];
    const canViewWeeklyReview = computed(() => {
      const partnerGroups = Array.isArray(bSettings?.env?.partner_groups) ? bSettings.env.partner_groups : [];
      return bSettings?.env?.isPE === true && partnerGroups.includes('pe');
    });
    const registerView = ref(bSettings.swhandle == 'ddnews');
    const folderList = getFoldersFormList(bSettings);
    const currentFolder = computed(() => {
      return getCurrentFolder('attendance', folderList)
    })
    const selectedIndex = ref(0)
    const tabKey = ref(0)
    const tabsList = ref([])
    const childRef = ref(null);

    let newRow = false;
    let isEdited = false;
    let deselectAllCalled = false;
    console.log(deselectAllCalled)
    let showInOut = false;
    let toggleCellColor = false;
    let showSitesCellColor = false;
    let showDesignationsCellColor = false;
    const onGridReadyCalled = ref(false);
    const gridDataSource = ref({});
    const filterValues = ref({
      contract: null,
      employee:null,
      site:null,
      shift:null,
      designation: null,
      department:null,
      attendanceType:null,
      reportingManger:null,
      weeklyReviewMode: false,
      weeklyDateRange: null,
    });
    const weeklyReviewMode = ref(false);
    const weeklyReviewLoading = ref(false);
    const weeklyReviewRows = ref([]);
    let weeklyReviewRequestSequence = 0;
    let activeWeeklyReviewRequestId = null;
    const weeklyGridApi = ref(null);
    const weeklyGridHeight = ref('76vh');
    const weeklyRowHeight = ref(90);
    const selectedWeekStart = ref(getCurrentWeekStartSunday());
    const selectedCells = ref([]);
    let selectAll = false;
    const cellSelected = ref([]);
    const activeSelectionTool = ref('');
    const isHideUnselected = ref(false);
    //adding sort ref
    const fieldToSortEmployeeRows = ref('name')
    const orderToSortEmployeeRows = ref('asc')

    function sortWeeklyRowsByEmployee(rows) {
      const rowsCopy = Array.isArray(rows) ? [...rows] : [];
      const sortBy = fieldToSortEmployeeRows.value === 'code' ? 'code' : 'name';
      const sortOrder = orderToSortEmployeeRows.value === 'desc' ? 'desc' : 'asc';
      rowsCopy.sort((a, b) => {
        const aValue = sortBy === 'code'
          ? (a?.employees?.[0]?.code ?? a?.employeeCode ?? '')
          : (a?.employees?.[0]?.persons_id?.[0]?.first_name?.eng ?? a?.employeeName ?? '');
        const bValue = sortBy === 'code'
          ? (b?.employees?.[0]?.code ?? b?.employeeCode ?? '')
          : (b?.employees?.[0]?.persons_id?.[0]?.first_name?.eng ?? b?.employeeName ?? '');
        const comparison = String(aValue).trim().localeCompare(String(bValue).trim());
        return sortOrder === 'desc' ? comparison * -1 : comparison;
      });
      return rowsCopy;
    }

    function startWeeklyReviewRequest() {
      const requestId = weeklyReviewRequestSequence + 1;
      weeklyReviewRequestSequence = requestId;
      activeWeeklyReviewRequestId = requestId;
      weeklyReviewLoading.value = true;
      return requestId;
    }

    function isActiveWeeklyReviewRequest(requestId) {
      return requestId !== null && activeWeeklyReviewRequestId === requestId;
    }

    function cancelWeeklyReviewRequests() {
      activeWeeklyReviewRequestId = null;
      weeklyReviewLoading.value = false;
    }

    function handleSortRowsOn(fieldToSortOn) {
      fieldToSortEmployeeRows.value = fieldToSortOn;
      if (orderToSortEmployeeRows.value === 'asc') {
        orderToSortEmployeeRows.value = 'desc';
      } else {
        orderToSortEmployeeRows.value = 'asc';
      }
      if (weeklyReviewMode.value) {
        weeklyReviewRows.value = sortWeeklyRowsByEmployee(weeklyReviewRows.value);
        weeklyGridApi.value?.refreshHeader();
        weeklyGridApi.value?.refreshCells({ force: true });
      } else if (gridApi.value !== undefined && gridApi.value !== null) {
        gridApi.value.refreshInfiniteCache();
      }
    }
    const customTabsClass = computed(() => {
      //change background and give maximum height
      return 'bg-body h-100 p-2'
    })
    const isRenderComplete = ref(false);

    // compute days directly from timeRange
    const daysInSelectedMonth = computed(() => {
      return new Date(timeRange.value.year, timeRange.value.month, 0).getDate();
    });

    const onModelUpdated = (params) => {
      isRenderComplete.value = true;
      requestAnimationFrame(() => {
        const rowCount = params.api.getDisplayedRowCount();

        isRenderComplete.value = (rowCount === daysInSelectedMonth.value) ? false : true;
      });
    };

    function formatInputDate(dateValue) {
      const year = dateValue.getFullYear();
      const month = String(dateValue.getMonth() + 1).padStart(2, '0');
      const day = String(dateValue.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    function parseInputDate(dateInput) {
      if (!dateInput || typeof dateInput !== 'string') {
        return null;
      }
      const [yearPart, monthPart, dayPart] = dateInput.split('-');
      const year = Number(yearPart);
      const month = Number(monthPart);
      const day = Number(dayPart);
      if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
        return null;
      }
      const parsedDate = new Date(year, month - 1, day);
      if (Number.isNaN(parsedDate.getTime())) {
        return null;
      }
      parsedDate.setHours(0, 0, 0, 0);
      return parsedDate;
    }

    function formatDisplayDate(dateValue) {
      const day = String(dateValue.getDate()).padStart(2, '0');
      const month = String(dateValue.getMonth() + 1).padStart(2, '0');
      const year = dateValue.getFullYear();
      return `${day}/${month}/${year}`;
    }

    function normalizeToSunday(dateValue) {
      const date = new Date(dateValue);
      date.setHours(0, 0, 0, 0);
      date.setDate(date.getDate() - date.getDay());
      return date;
    }

    function getFirstSundayInMonth(year, month) {
      const firstDay = new Date(year, month - 1, 1);
      firstDay.setHours(0, 0, 0, 0);
      const dayOffset = (7 - firstDay.getDay()) % 7;
      firstDay.setDate(firstDay.getDate() + dayOffset);
      return firstDay;
    }

    function getLastSundayInMonth(year, month) {
      const lastDay = new Date(year, month, 0);
      lastDay.setHours(0, 0, 0, 0);
      lastDay.setDate(lastDay.getDate() - lastDay.getDay());
      return lastDay;
    }

    function getCurrentWeekStartSunday() {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      currentDate.setDate(currentDate.getDate() - currentDate.getDay());
      return formatInputDate(currentDate);
    }

    function formatAttendanceRangeBoundary(date, isEnd = false) {
      const timestamp = new Date(Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        isEnd ? 23 : 0,
        isEnd ? 59 : 0,
        isEnd ? 59 : 0
      ));
      const formattedTimestamp = timestamp.toISOString().replace('T', ' ').slice(0, 19);
      const inputDate = new Date(formattedTimestamp);
      inputDate.setHours(inputDate.getHours() - 5);
      inputDate.setMinutes(inputDate.getMinutes() - 30);
      const year = inputDate.getFullYear();
      const month = String(inputDate.getMonth() + 1).padStart(2, '0');
      const day = String(inputDate.getDate()).padStart(2, '0');
      const hours = String(inputDate.getHours()).padStart(2, '0');
      const minutes = String(inputDate.getMinutes()).padStart(2, '0');
      const seconds = String(inputDate.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    function getWeekRangeFromStartDate(startDateInput) {
      if (!startDateInput || typeof startDateInput !== 'string') {
        return null;
      }
      const [yearPart, monthPart, dayPart] = startDateInput.split('-');
      const year = Number(yearPart);
      const month = Number(monthPart);
      const day = Number(dayPart);
      if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
        return null;
      }
      const localDate = new Date(year, month - 1, day);
      if (Number.isNaN(localDate.getTime())) {
        return null;
      }
      const weekStartLocal = new Date(localDate);
      weekStartLocal.setHours(0, 0, 0, 0);
      weekStartLocal.setDate(localDate.getDate() - localDate.getDay());
      const weekEndLocal = new Date(weekStartLocal);
      weekEndLocal.setDate(weekStartLocal.getDate() + 6);
      const weekEndInclusive = new Date(weekEndLocal);
      weekEndInclusive.setUTCHours(23, 59, 59, 999);

      const weekStartUtc = new Date(Date.UTC(
        weekStartLocal.getFullYear(),
        weekStartLocal.getMonth(),
        weekStartLocal.getDate()
      ));
      const weekEndUtc = new Date(Date.UTC(
        weekEndLocal.getFullYear(),
        weekEndLocal.getMonth(),
        weekEndLocal.getDate()
      ));

      const dayMeta = [];
      for (let i = 0; i < 7; i++) {
        const dayDate = new Date(weekStartLocal);
        dayDate.setDate(weekStartLocal.getDate() + i);
        const dateKey = formatInputDate(dayDate);
        const weekDay = dayDate.toLocaleDateString('en-US', { weekday: 'short' });
        const dateLabel = dayDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
        dayMeta.push({
          dateKey,
          headerName: `${weekDay} ${dateLabel}`,
        });
      }

      return {
        start: formatAttendanceRangeBoundary(weekStartUtc, false),
        end: formatAttendanceRangeBoundary(weekEndUtc, true),
        startDate: weekStartLocal.toISOString(),
        endDate: weekEndInclusive.toISOString(),
        weekStartInput: formatInputDate(weekStartLocal),
        dayMeta,
        dayKeys: dayMeta.map((dayInfo) => dayInfo.dateKey),
      };
    }

    function getAttendanceCode(value, fallbackCode = 'A') {
      if (value === undefined || value === null) {
        return fallbackCode;
      }
      const attCode = value?.att_type?.[0]?.code
        ?? value?.att_type?.code
        ?? value?.attendance_code
        ?? null;
      if (attCode === 'L' && value?.leave_type?.[0]?.code) {
        return value.leave_type[0].code;
      }
      return attCode ?? fallbackCode;
    }

    function getRecordedAttendanceException(exceptionList) {
      if (!Array.isArray(exceptionList) || exceptionList.length === 0) {
        return null;
      }
      return exceptionList.find((entry) => entry?.description === 'Recorded Attendance') ?? null;
    }

    function getWeeklyReviewTransitionExceptions(attendanceCell) {
      const exceptionList = Array.isArray(attendanceCell?.exception) ? attendanceCell.exception : [];
      return exceptionList.filter((entry) => {
        const description = String(entry?.description ?? '').toLowerCase();
        return !(entry?.type === 'system' && description.includes('attendance rejected'));
      });
    }

    function getAttendanceDateKey(attendanceDate) {
      const date = new Date(attendanceDate);
      if (Number.isNaN(date.getTime())) {
        return null;
      }
      date.setHours(date.getHours() + 5);
      date.setMinutes(date.getMinutes() + 30);
      return formatInputDate(date);
    }

    function getAttendanceTransitionEntries(attendanceCell) {
      const exceptionList = getWeeklyReviewTransitionExceptions(attendanceCell);
      const sortedExceptions = [...exceptionList].sort((a, b) => {
        if (!a?.edit_timestamp && !b?.edit_timestamp) return 0;
        if (!a?.edit_timestamp) return -1;
        if (!b?.edit_timestamp) return 1;
        return new Date(a.edit_timestamp).getTime() - new Date(b.edit_timestamp).getTime();
      });
      const recordedAttendance = getRecordedAttendanceException(sortedExceptions);
      const entries = [];
      let previousState = recordedAttendance !== null ? getAttendanceCode(recordedAttendance, 'A') : 'A';
      sortedExceptions.forEach((exceptionEntry) => {
        const statusCode = getAttendanceCode(exceptionEntry, null);
        if (statusCode !== null && statusCode !== undefined && previousState !== statusCode) {
          entries.push({
            transition: `${previousState}->${statusCode}`,
            remark: exceptionEntry?.description ?? null,
          });
          previousState = statusCode;
        }
      });

      const currentStatus = getAttendanceCode(attendanceCell, previousState || 'A');
      if (previousState !== currentStatus) {
        entries.push({
          transition: `${previousState}->${currentStatus}`,
          remark: null,
        });
      }
      return entries;
    }

    function normalizeOvertimeMinutes(value) {
      if (value === null || value === undefined || Number.isNaN(Number(value))) {
        return 0;
      }
      return Number(value);
    }

    function getOvertimeTransitionPairs(attendanceCell) {
      const exceptionList = getWeeklyReviewTransitionExceptions(attendanceCell);
      const sortedExceptions = [...exceptionList].sort((a, b) => {
        if (!a?.edit_timestamp && !b?.edit_timestamp) return 0;
        if (!a?.edit_timestamp) return -1;
        if (!b?.edit_timestamp) return 1;
        return new Date(a.edit_timestamp).getTime() - new Date(b.edit_timestamp).getTime();
      });
      const recordedAttendance = getRecordedAttendanceException(sortedExceptions);
      const overtimeStates = [normalizeOvertimeMinutes(recordedAttendance?.overtime_minutes)];

      sortedExceptions.forEach((exceptionEntry) => {
        const overtimeMinutes = normalizeOvertimeMinutes(exceptionEntry?.overtime_minutes);
        if (overtimeStates[overtimeStates.length - 1] !== overtimeMinutes) {
          overtimeStates.push(overtimeMinutes);
        }
      });

      const currentOvertime = normalizeOvertimeMinutes(attendanceCell?.overtime_minutes);
      if (overtimeStates[overtimeStates.length - 1] !== currentOvertime) {
        overtimeStates.push(currentOvertime);
      }

      if (overtimeStates.length < 2) {
        return [];
      }

      const overtimePairs = [];
      for (let i = 0; i < overtimeStates.length - 1; i++) {
        overtimePairs.push(`OT: ${convertMinutesToHoursFormat(overtimeStates[i])}->${convertMinutesToHoursFormat(overtimeStates[i + 1])}`);
      }
      return overtimePairs;
    }

    function getWeeklyReviewCellPayload(attendanceCell) {
      const clonedCell = JSON.parse(JSON.stringify(attendanceCell));
      const hasException = Array.isArray(attendanceCell?.exception) && attendanceCell.exception.length > 0;
      if (hasException) {
        clonedCell.weekly_review_reject_allowed = true;
      }
      return clonedCell;
    }

    function getSelectedCellMapByEmployee(employeeId) {
      const employeeKey = employeeId !== undefined && employeeId !== null ? String(employeeId) : null;
      if (!employeeKey) {
        return null;
      }
      const matchedEntry = selectedCells.value.find((entry) => Object.prototype.hasOwnProperty.call(entry, employeeKey));
      if (!matchedEntry) {
        return null;
      }
      return matchedEntry[employeeKey] ?? null;
    }

    function isWeeklyCellSelected(rowData, dayKey) {
      const reviewCellsByDay = rowData?.__reviewCellsByDay?.[dayKey];
      if (!reviewCellsByDay || Object.keys(reviewCellsByDay).length === 0) {
        return false;
      }
      if (selectAll) {
        return true;
      }
      const selectedCellMap = getSelectedCellMapByEmployee(rowData?.employeeId);
      if (!selectedCellMap) {
        return false;
      }
      return Object.keys(reviewCellsByDay).some((columnKey) => selectedCellMap[columnKey] !== undefined);
    }

    function isWeeklyRowSelected(rowData) {
      const reviewCells = rowData?.__reviewCells ?? {};
      const reviewCellKeys = Object.keys(reviewCells);
      if (reviewCellKeys.length === 0) {
        return false;
      }
      if (selectAll) {
        return true;
      }
      const selectedCellMap = getSelectedCellMapByEmployee(rowData?.employeeId);
      if (!selectedCellMap) {
        return false;
      }
      return reviewCellKeys.some((columnKey) => selectedCellMap[columnKey] !== undefined);
    }

    function getWeeklyCellText(rowData, dayKey) {
      if (!rowData) {
        return '';
      }
      if (isHideUnselected.value && !isWeeklyCellSelected(rowData, dayKey)) {
        return '';
      }
      return rowData?.[dayKey]?.text ?? '';
    }

    function getWeeklyCellStyle(rowData, dayKey) {
      const isSelected = isWeeklyCellSelected(rowData, dayKey);
      const isHidden = isHideUnselected.value && !isSelected;
      return {
        whiteSpace: 'pre-line',
        lineHeight: '1.25',
        fontSize: '12px',
        paddingTop: '4px',
        paddingBottom: '4px',
        backgroundColor: isSelected
          ? 'var(--ag-selected-row-background-color, rgba(94, 128, 168, 0.18))'
          : (isHidden ? '#edf2f7' : '#fbfcfe'),
        color: isHidden ? '#8a96a5' : 'var(--ag-foreground-color, #000000)',
      };
    }

    function getWeeklyReviewColumnDefs() {
      const rangeInfo = filterValues.value.weeklyDateRange;
      const dayMeta = Array.isArray(rangeInfo?.dayMeta) ? rangeInfo.dayMeta : [];
      const dayColumns = dayMeta.map((dayInfo) => ({
        headerName: dayInfo.headerName,
        headerComponent: 'GridHeaderComponent',
        field: dayInfo.dateKey,
        minWidth: 150,
        valueGetter: (params) => getWeeklyCellText(params.data, dayInfo.dateKey),
        tooltipValueGetter: (params) => getWeeklyCellText(params.data, dayInfo.dateKey),
        sortable: false,
        filter: false,
        cellStyle: (params) => getWeeklyCellStyle(params.data, dayInfo.dateKey),
      }));

      return [
        {
          headerName: 'Employees',
          field: 'employees',
          minWidth: 220,
          maxWidth: 300,
          pinned: 'left',
          suppressSizeToFit: false,
          unSortIcon: true,
          sortable: true,
          suppressMovable: true,
          suppressMenu: true,
          filter: 'agTextColumnFilter',
          filterParams: {
            filterOptions: ['equals'],
            maxNumConditions: 1,
            closeOnApply: false,
            debounceMs: 1000,
          },
          filterValueGetter: (params) => {
            const name = params.data?.employees?.[0]?.persons_id?.[0]?.first_name?.eng ?? params.data?.employeeName ?? '';
            const code = params.data?.employees?.[0]?.code ?? params.data?.employeeCode ?? '';
            return `${name} ${code}`;
          },
          enableCellChangeFlash: true,
          cellRendererSelector: () => ({ component: EmployeeCellRenderer }),
          cellRendererParams: {
            gridView: 'attendance',
            openCalendar: openCalendar,
            updateFilterValues: updateFilterValues,
            showRegisterView: showRegisterView
          },
          headerComponent: CustomEmployeeColHeader,
          headerComponentParams: {
            handleSortRowsOn: handleSortRowsOn,
            gridApi: gridApi.value
          },
          cellStyle: (params) => {
            const rowSelected = isWeeklyRowSelected(params.data);
            return {
              fontSize: '14px',
              border: '0.1px solid #dde2eb',
              justifyContent: 'center',
              backgroundColor: rowSelected
                ? 'var(--ag-selected-row-background-color, rgba(94, 128, 168, 0.18))'
                : '#f7f9fc',
              color: 'var(--ag-foreground-color, #000000)',
            };
          },
        },
        ...dayColumns,
      ];
    }

    function clampWeekStartToSelectedMonth(weekStartInput) {
      const minDate = parseInputDate(weekPickerMinDate.value);
      const maxDate = parseInputDate(weekPickerMaxDate.value);
      if (!minDate || !maxDate) {
        return getCurrentWeekStartSunday();
      }
      let selectedDate = parseInputDate(weekStartInput);
      if (!selectedDate) {
        selectedDate = new Date(minDate);
      }
      selectedDate = normalizeToSunday(selectedDate);
      if (selectedDate.getTime() < minDate.getTime()) {
        selectedDate = new Date(minDate);
      }
      if (selectedDate.getTime() > maxDate.getTime()) {
        selectedDate = new Date(maxDate);
      }
      return formatInputDate(selectedDate);
    }

    function syncWeeklyFilterState() {
      selectedWeekStart.value = clampWeekStartToSelectedMonth(selectedWeekStart.value);
      filterValues.value.weeklyReviewMode = weeklyReviewMode.value;
      if (!weeklyReviewMode.value) {
        filterValues.value.weeklyDateRange = null;
        return;
      }
      const weekRange = getWeekRangeFromStartDate(selectedWeekStart.value);
      filterValues.value.weeklyDateRange = weekRange;
    }

    function shiftWeek(days) {
      const selectedDate = parseInputDate(selectedWeekStart.value) ?? parseInputDate(weekPickerMinDate.value);
      if (!selectedDate) {
        return;
      }
      const shiftedDate = new Date(selectedDate);
      shiftedDate.setDate(shiftedDate.getDate() + days);
      selectedWeekStart.value = clampWeekStartToSelectedMonth(formatInputDate(shiftedDate));
      onWeeklyRangeChange();
    }

    function goToPreviousWeek() {
      if (!canGoToPreviousWeek.value) {
        return;
      }
      shiftWeek(-7);
    }

    function goToNextWeek() {
      if (!canGoToNextWeek.value) {
        return;
      }
      shiftWeek(7);
    }

    function goToCurrentWeek() {
      selectedWeekStart.value = clampWeekStartToSelectedMonth(getCurrentWeekStartSunday());
      onWeeklyRangeChange();
    }

    function buildWeeklyReviewRows(attendanceRows) {
      if (!Array.isArray(attendanceRows) || attendanceRows.length === 0) {
        return [];
      }
      const result = [];
      const weekRange = filterValues.value.weeklyDateRange;
      const dayKeys = Array.isArray(weekRange?.dayKeys) ? weekRange.dayKeys : [];
      const dayKeySet = new Set(dayKeys);
      attendanceRows.forEach((employeeRow) => {
        const employee = employeeRow?.employees?.[0];
        if (!employee?.id) {
          return;
        }
        const employeeName = employee?.persons_id?.[0]?.first_name?.eng ?? '-';
        const employeeCode = employee?.code ?? '-';
        const weeklyRow = {
          id: employee.id,
          employeeId: employee.id,
          employeeCode,
          employeeName,
          employees: employeeRow?.employees,
          __reviewCells: {},
          __reviewCellsByDay: {},
        };
        dayKeys.forEach((dayKey) => {
          weeklyRow[dayKey] = { text: '' };
        });
        let hasReviewChanges = false;

        Object.keys(employeeRow).forEach((columnKey) => {
          if (columnKey === 'employees' || columnKey === 'att_sum') {
            return;
          }
          const attendanceCell = employeeRow[columnKey];
          if (!attendanceCell || !attendanceCell.attendance_date) {
            return;
          }
          const attendanceStatusCode = attendanceCell?.attendance_status?.[0]?.code;
          if (attendanceStatusCode !== 'unapproved') {
            return;
          }
          const attendanceDayKey = getAttendanceDateKey(attendanceCell.attendance_date);
          if (!attendanceDayKey || !dayKeySet.has(attendanceDayKey)) {
            return;
          }
          const transitionEntries = getAttendanceTransitionEntries(attendanceCell);
          const transitionLines = transitionEntries.flatMap((entry) => {
            const lines = [entry.transition];
            if (entry.remark) {
              lines.push(`Remark: ${entry.remark}`);
            }
            return lines;
          });
          const overtimePairs = getOvertimeTransitionPairs(attendanceCell);
          const reviewLines = [...transitionLines, ...overtimePairs];
          if (reviewLines.length === 0) {
            return;
          }
          const currentText = weeklyRow[attendanceDayKey]?.text ?? '';
          weeklyRow[attendanceDayKey] = {
            text: currentText.length > 0
              ? `${currentText}\n${reviewLines.join('\n')}`
              : reviewLines.join('\n'),
          };
          if (!weeklyRow.__reviewCellsByDay[attendanceDayKey]) {
            weeklyRow.__reviewCellsByDay[attendanceDayKey] = {};
          }
          weeklyRow.__reviewCellsByDay[attendanceDayKey][columnKey] = getWeeklyReviewCellPayload(attendanceCell);
          weeklyRow.__reviewCells[columnKey] = getWeeklyReviewCellPayload(attendanceCell);
          hasReviewChanges = true;
        });

        if (hasReviewChanges) {
          result.push(weeklyRow);
        }
      });
      return sortWeeklyRowsByEmployee(result);
    }


    const currentDateTime = new Date();
    const timeRange = ref({
      startWeek: null,
      endWeek:null,
      day: 1,
      year: currentDateTime.getFullYear(),
      month: currentDateTime.getMonth() + 1
    });
    const weekPickerMinDate = computed(() => {
      return formatInputDate(getFirstSundayInMonth(timeRange.value.year, timeRange.value.month));
    });
    const weekPickerMaxDate = computed(() => {
      return formatInputDate(getLastSundayInMonth(timeRange.value.year, timeRange.value.month));
    });
    const canGoToPreviousWeek = computed(() => {
      const selectedDate = parseInputDate(selectedWeekStart.value);
      const minDate = parseInputDate(weekPickerMinDate.value);
      if (!selectedDate || !minDate) {
        return false;
      }
      return selectedDate.getTime() > minDate.getTime();
    });
    const canGoToNextWeek = computed(() => {
      const selectedDate = parseInputDate(selectedWeekStart.value);
      const maxDate = parseInputDate(weekPickerMaxDate.value);
      if (!selectedDate || !maxDate) {
        return false;
      }
      return selectedDate.getTime() < maxDate.getTime();
    });
    const weeklyRangeDisplay = computed(() => {
      const weekRange = filterValues.value.weeklyDateRange;
      const weekStart = parseInputDate(weekRange?.weekStartInput ?? selectedWeekStart.value);
      if (!weekStart) {
        return '';
      }
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekEnd.getDate() + 6);
      return `${formatDisplayDate(weekStart)} - ${formatDisplayDate(weekEnd)}`;
    });
    const gridApi = ref();
    const newRows = ref();
    let copyValue = null;
    let copyTempValue = null;
    const currEmpAttData = ref([]);
    let selectedRows = [];
    // const defaultColDef = ref({
    //   flex: 1,
    //   resizable: true,
    //   minWidth: 100,
    //   tooltipComponent: registerView.value ? 'RegisterToolTip' : 'AttendanceCellDetailsRenderer',
    //   enableBrowserTooltips: false
    // });
    const defaultColDefRegister = {
      flex: 1,
      resizable: true,
      minWidth: 100,
      tooltipComponent: 'RegisterToolTip',
      enableBrowserTooltips: false
    };

    const defaultColDefAttendance = {
      flex: 1,
      resizable: true,
      minWidth: 100,
      tooltipComponent: 'AttendanceCellDetailsRenderer',
      enableBrowserTooltips: false
    };
    const gridHeight = ref('76vh');
    const rowHeight = ref('70');
    const headerHeight = ref('60');
    const rowBuffer = ref(null);
    const rowSelection = ref(null);
    const rowModelType = ref(null);
    const cacheBlockSize = ref(null);
    const cacheOverflowSize = ref(null);
    const maxConcurrentDatasourceRequests = ref(null);
    const infiniteInitialRowCount = ref(null);
    const maxBlocksInCache = ref(null);
    const gridData = ref(null);
    const pinnedBottomRowData = ref(null);
    const totalRowCount = ref(0);
    const showLoader = ref();
    const suppressRowSelection = ref();
    const suppressRowClickSelection = ref();
    const stopEditingWhenGridLosesFocus = ref();
    const loadingOverlayComponent = ref();
    const loadingOverlayComponentParams = ref();
    // Define the column definitions for the ag-Grid

    const gridColumnDefs = [
      {
        headerName: 'Employees',
        pinned: 'left',
        minWidth: 200,
        maxWidth: 300,
        suppressSizeToFit: false,
        field: 'employees',
        unSortIcon: true,
        sortable: true,
        suppressMovable: true,
        suppressMenu:true,
        cellEditor: EmployeeCellEditor,
        // suppressMenu: true,
        editable: (params) => {
          if (params.node.rowPinned) {
            return false;
          }
          // if (Object.keys(params.data).length < 2)
          return true;
        },
        filter:'agTextColumnFilter',
        filterParams: {
          filterOptions: ['equals'],
          maxNumConditions: 1,
          closeOnApply: false,
          debounceMs: 1000,
        },

        enableCellChangeFlash: true,
        cellStyle: {
          color: 'black',
          fontSize: '14px',
          border: '0.1px solid #dde2eb',
          'justify-content': 'center',
        },
        cellEditorParams: {
          'currentFolder':currentFolder.value,
        },
        cellRendererSelector: (params) => {
          if (params.node.rowPinned) {
            return {
              component: PinnedRowRenderer,
            };
          } else {
            return {
              component: EmployeeCellRenderer,
            };
          }
        },
        cellRendererParams : {
          gridView: 'attendance',
          openCalendar : openCalendar,
          updateFilterValues: updateFilterValues,
          showRegisterView: showRegisterView
        },
        headerComponent: CustomEmployeeColHeader,
        headerComponentParams: {
          handleSortRowsOn: handleSortRowsOn,
          gridApi:gridApi.value
        },
      },
      ...attendancePeriodColumns(timeRange.value, gridDataSource.value, showSitesCellColor, showDesignationsCellColor, isEditedEnable, selectedCells.value, selectAll, showInOut, activeSelectionTool.value, isHideUnselected.value),
      {
        field: 'total',
        maxWidth: 350,
        minWidth: 300,
        sortable: false,
        suppressMovable: true,
        enableCellChangeFlash: true,
        cellRendererSelector: (params) => {
          if (params.node.rowPinned) {
            return {
              component: PinnedRowRenderer,
            };
          }
          return {
            component: TotalHoursCellRenderer,
          };
        },
        cellRendererParams: {
          'currentFolder': currentFolder.value,
        },
        pinned: 'right',
        headerComponent: TotalHoursHeaderComponent,
        headerComponentParams: {
          addNewRow: addNewRow,
          clearSelection:clearSelection
        },
        cellStyle: {
          color: 'black',
          fontSize: '14px',
          border: '0.1px solid #dde2eb',
        },
      },
    ];
    const weeklyReviewColumnDefs = computed(() => getWeeklyReviewColumnDefs());
    const defaultColDefWeeklyReview = {
      resizable: true,
      sortable: false,
      filter: false,
      suppressMenu: true,
    };
    const registerViewColumnDefs = [ ...attendanceRegisterColumns(gridDataSource.value)];
    const columnDefs = ref(!registerView.value ? gridColumnDefs : registerViewColumnDefs);

    //calendar config
    const formOpen = ref(false)
    const formFolder =  bSettings?.output?.data?.records[0]?.business?.containers?.folders?.folders?.leaves;
    const txnForCalendar = bSettings?.output?.data?.records[0]?.business?.containers?.folders?.folders?.leaves?.txns?.txn_leaves_create;
    const keepAliveState = ref(null);
    const initialDate = computed(() => {
      if (Object.keys(timeRange.value).length !== 0) {
        const formattedDate = `${timeRange.value.year}-${String(timeRange.value.month).padStart(2, '0')}-01`;
        return formattedDate;
      }
      return new Date();
    });
    const calendarHeader = computed(() => {
      const empCode = currEmpAttData.value.employees?.[0]?.code
      const empName = currEmpAttData.value.employees?.[0]?.persons_id?.[0]?.first_name.eng
      return `${empName} (${empCode})`
    })


    async function setChecksForEdits(dateSet) {
      const { getCurrentSelectedPartnersId } = usePartnersId()

      //checks if the current view month of the grid has invoice generated for the contract within the period
      const startRange = new Date(dateSet.year, dateSet.month - 1, dateSet.day)
      const endRange = new Date(dateSet.year, dateSet.month, dateSet.day)
      const { getFolderByName } = getFolders()
      const folderToUse = getFolderByName('invoices', bSettings)
      const { listData } = postData()
      const txnParams = {}
      txnParams.refRows = true
      const invoicePeriodValue = `["${startRange?.toISOString().replace('T', ' ').slice(0, -5)}", "${endRange?.toISOString().replace('T', ' ').slice(0, -5)}")`
      const filterForInvoice = {
        'filterInput':[
          {
            'filterInput': [
              {
                'path': 'invoices.invoice_period',
                'operator':'&&',
                'value': invoicePeriodValue
                //'value': [startRange.toISOString(), endRange.toISOString()]
              },
              {
                'path':'invoices.partners_id',
                'operator':'=',
                'value':getCurrentSelectedPartnersId()
              }

            ],
            'joinop':'and'
          }

        ],
        'joinop':'and'
      }

      txnParams.filters = filterForInvoice
      txnParams.projections = projectionForFolder('invoice_in_attendance')
      const list = await listData(folderToUse, txnParams)
      const { fatRowGenerator } = getFatRow()
      const records = fatRowGenerator(list)
      console.log('invoice', list, records, invoicePeriodValue)
      if (records.length > 0) {
        gridDataSource.value['invoices_generated'] = true
      }
      else {
        gridDataSource.value['invoices_generated'] = false
      }


    }
    const calendarParams = () => {
      const { empLeaveSelectAllow, eventClassNames, refBy, events, eventContent } = calendarUtils();
      return {
        'select-allow' : empLeaveSelectAllow(currEmpAttData),
        'readOnly':true,
        'selectable': true,
        'actionString': 'Apply for leave',
        'events': events(currEmpAttData),
        'eventClassNames': eventClassNames,
        'folder':formFolder,
        'txnToUse':txnForCalendar,
        'eventContent': eventContent,
        'header':calendarHeader.value,
        'refBy': refBy(currEmpAttData, formFolder),
        'initialDate': initialDate.value,
        'current-task':'create'
      }
    }

    function openCalendar(employeeAttData) {
      currEmpAttData.value = employeeAttData;
      formOpen.value = true
      selectedIndex.value = 0
      tabsList.value.push(
        {
          label:'Calender',
          component:'WfmCalendar',
          name:'calender',
          params:calendarParams()
        }
      )
    }

    function closeCalendar() {
      //empty the tabslist and close the modal
      tabsList.value = []
      console.log('AttendanceGrid closing form ...')
      formOpen.value = false;
      keepAliveState.value = null;
    }

    function updateKeepAliveState(selectionInfo) {
      if (selectionInfo !== undefined && selectionInfo !== null) {
        keepAliveState.value = selectionInfo;
      } else {
        keepAliveState.value = null
      }
    }

    function changeTab(index) {
      selectedIndex.value = index
    }
    function addTab(tabSpec) {
      const idx = tabsList.value.findIndex((obj) => obj.name === tabSpec.name)
      if (idx < 0) {
        tabsList.value.push(tabSpec)
        selectedIndex.value = tabsList.value.length - 1
      }
      else {
        selectedIndex.value = idx
      }
    }

    function delTab(index) {
      tabsList.value.splice(index, 1)
    }
    // calendar config end

    //
    function isEditedEnable(isEditing) {
      isEdited = isEditing;
      console.log(isEdited)
    }

    function showRegisterView(value) {
      registerView.value = value;
      if (registerView.value) {
        weeklyReviewMode.value = false;
        syncWeeklyFilterState();
      }
      if (registerView.value) {
        gridApi.value = undefined;
        rowBuffer.value = 0;
        rowModelType.value = 'infinite';
        rowSelection.value = 'multiple';
        cacheBlockSize.value = 100;
        cacheOverflowSize.value = 2;
        maxConcurrentDatasourceRequests.value = 1;
        infiniteInitialRowCount.value = 0;
        maxBlocksInCache.value = 50;
        pinnedBottomRowData.value = !registerView.value ? [0] : null;
        showLoader.value = true;
        suppressRowSelection.value = true;
        suppressRowClickSelection.value = true;
        stopEditingWhenGridLosesFocus.value = true;
        headerHeight.value = '30';
      } else {
        gridApi.value = null;
        rowBuffer.value = 0;
        rowModelType.value = 'infinite';
        rowSelection.value = 'multiple';
        cacheBlockSize.value = 100;
        cacheOverflowSize.value = 2;
        maxConcurrentDatasourceRequests.value = 1;
        infiniteInitialRowCount.value = 0;
        maxBlocksInCache.value = 50;
        pinnedBottomRowData.value = !registerView.value ? [0] : null;
        showLoader.value = true;
        suppressRowSelection.value = true;
        suppressRowClickSelection.value = true;
        stopEditingWhenGridLosesFocus.value = true;
        rowHeight.value = '70';
        headerHeight.value = '60';
        selectAll = false;
      }
      setHeaderNames(timeRange.value)
      setChecksForEdits(timeRange.value)
    }

    function showInOutTimeToggle(inOutTime) {
      showInOut = inOutTime;
      const monthGroupColumnsDefs = attendancePeriodColumns(timeRange.value, gridDataSource.value, showSitesCellColor, showDesignationsCellColor, isEditedEnable, selectedCells.value, selectAll, showInOut, activeSelectionTool.value, isHideUnselected.value)
      const columnDefs = gridApi.value.getColumnDefs()
      const columnsArray = [];
      if (columnDefs !== undefined && columnDefs !== null) {
        columnsArray.push(columnDefs[0]);
        columnsArray.push(...monthGroupColumnsDefs);
        columnsArray.push(columnDefs[columnDefs.length - 1]);
        gridApi.value.setColumnDefs(columnsArray)
      }
    }

    function onWeeklyReviewModeToggle(nextMode = null) {
      if (typeof nextMode === 'boolean') {
        weeklyReviewMode.value = nextMode;
      }
      if (weeklyReviewMode.value && registerView.value) {
        showRegisterView(false);
      }
      if (!weeklyReviewMode.value) {
        cancelWeeklyReviewRequests();
      } else {
        weeklyReviewLoading.value = true;
      }
      syncWeeklyFilterState();
      clearWeeklySelection();
      if (gridApi.value !== undefined && gridApi.value !== null) {
        clearSelection();
        gridApi.value.refreshInfiniteCache();
      }
    }

    function onWeeklyRangeChange(nextWeekStart = null) {
      if (typeof nextWeekStart === 'string' && nextWeekStart.length > 0) {
        selectedWeekStart.value = clampWeekStartToSelectedMonth(nextWeekStart);
      }
      syncWeeklyFilterState();
      clearWeeklySelection();
      if (gridApi.value !== undefined && gridApi.value !== null && weeklyReviewMode.value) {
        weeklyReviewLoading.value = true;
        gridApi.value.refreshInfiniteCache();
      }
    }

    function onWeeklyGridReady(params) {
      weeklyGridApi.value = params.api;
      params.api.sizeColumnsToFit();
    }

    function filterSelectedCellsToWeeklyRange(cellsSelected) {
      if (!Array.isArray(cellsSelected) || !weeklyReviewMode.value) {
        return Array.isArray(cellsSelected) ? cellsSelected : [];
      }
      const allowedCellsByEmployee = {};
      const canonicalCellsByEmployee = {};
      weeklyReviewRows.value.forEach((row) => {
        const employeeKey = row?.employeeId !== undefined && row?.employeeId !== null ? String(row.employeeId) : null;
        if (!employeeKey) {
          return;
        }
        allowedCellsByEmployee[employeeKey] = new Set(Object.keys(row?.__reviewCells ?? {}));
        canonicalCellsByEmployee[employeeKey] = row?.__reviewCells ?? {};
      });
      const filteredResult = [];
      cellsSelected.forEach((entry) => {
        if (!entry || typeof entry !== 'object') {
          return;
        }
        const employeeKey = Object.keys(entry)[0];
        const allowedSet = allowedCellsByEmployee[employeeKey];
        if (!employeeKey || !allowedSet) {
          return;
        }
        const currentCellMap = entry[employeeKey] ?? {};
        const canonicalCellMap = canonicalCellsByEmployee[employeeKey] ?? {};
        const filteredCellMap = {};
        Object.keys(currentCellMap).forEach((columnKey) => {
          if (allowedSet.has(columnKey)) {
            const reviewCell = canonicalCellMap[columnKey] ?? currentCellMap[columnKey];
            filteredCellMap[columnKey] = JSON.parse(JSON.stringify(reviewCell));
          }
        });
        if (Object.keys(filteredCellMap).length > 0) {
          filteredResult.push({ [employeeKey]: filteredCellMap });
        }
      });
      return filteredResult;
    }

    function toggleWeeklyCellSelection(rowData, dayKey) {
      const employeeKey = rowData?.employeeId !== undefined && rowData?.employeeId !== null ? String(rowData.employeeId) : null;
      const reviewCellsByDay = rowData?.__reviewCellsByDay?.[dayKey];
      if (!employeeKey || !reviewCellsByDay || Object.keys(reviewCellsByDay).length === 0) {
        return;
      }
      const nextSelection = JSON.parse(JSON.stringify(selectedCells.value));
      let employeeEntry = nextSelection.find((entry) => Object.prototype.hasOwnProperty.call(entry, employeeKey));
      if (!employeeEntry) {
        employeeEntry = { [employeeKey]: {} };
        nextSelection.push(employeeEntry);
      }
      const employeeCellMap = employeeEntry[employeeKey];
      const dayColumnKeys = Object.keys(reviewCellsByDay);
      const isAlreadySelected = dayColumnKeys.some((columnKey) => employeeCellMap[columnKey] !== undefined);

      if (isAlreadySelected) {
        dayColumnKeys.forEach((columnKey) => {
          delete employeeCellMap[columnKey];
        });
      } else {
        dayColumnKeys.forEach((columnKey) => {
          employeeCellMap[columnKey] = JSON.parse(JSON.stringify(reviewCellsByDay[columnKey]));
        });
      }

      if (Object.keys(employeeCellMap).length === 0) {
        const indexToRemove = nextSelection.findIndex((entry) => Object.prototype.hasOwnProperty.call(entry, employeeKey));
        if (indexToRemove !== -1) {
          nextSelection.splice(indexToRemove, 1);
        }
      }
      selectedCells.value = nextSelection;
      cellSelected.value = nextSelection;
      selectAll = false;
      weeklyGridApi.value?.refreshCells({ force: true });
    }

    function toggleWeeklyRowSelection(rowData) {
      const employeeKey = rowData?.employeeId !== undefined && rowData?.employeeId !== null ? String(rowData.employeeId) : null;
      const reviewCells = rowData?.__reviewCells ?? {};
      const rowColumnKeys = Object.keys(reviewCells);
      if (!employeeKey || rowColumnKeys.length === 0) {
        return;
      }
      const nextSelection = JSON.parse(JSON.stringify(selectedCells.value));
      let employeeEntry = nextSelection.find((entry) => Object.prototype.hasOwnProperty.call(entry, employeeKey));
      if (!employeeEntry) {
        employeeEntry = { [employeeKey]: {} };
        nextSelection.push(employeeEntry);
      }
      const employeeCellMap = employeeEntry[employeeKey];
      const allRowCellsSelected = rowColumnKeys.every((columnKey) => employeeCellMap[columnKey] !== undefined);

      if (allRowCellsSelected) {
        rowColumnKeys.forEach((columnKey) => {
          delete employeeCellMap[columnKey];
        });
      } else {
        rowColumnKeys.forEach((columnKey) => {
          employeeCellMap[columnKey] = JSON.parse(JSON.stringify(reviewCells[columnKey]));
        });
      }

      if (Object.keys(employeeCellMap).length === 0) {
        const indexToRemove = nextSelection.findIndex((entry) => Object.prototype.hasOwnProperty.call(entry, employeeKey));
        if (indexToRemove !== -1) {
          nextSelection.splice(indexToRemove, 1);
        }
      }
      selectedCells.value = nextSelection;
      cellSelected.value = nextSelection;
      selectAll = false;
      weeklyGridApi.value?.refreshCells({ force: true });
    }

    function onWeeklyCellClicked(event) {
      if (!event?.event?.ctrlKey && !event?.event?.metaKey) {
        return;
      }
      const colId = event?.column?.colId;
      if (!colId) {
        return;
      }
      if (colId === 'employees' || colId === 'employeeName') {
        toggleWeeklyRowSelection(event.data);
        return;
      }
      toggleWeeklyCellSelection(event.data, colId);
    }

    function onWeeklyCellKeyDown(event) {
      if (event?.event?.code !== 'Space') {
        return;
      }
      const colId = event?.column?.colId;
      if (!colId || colId === 'employeeName' || colId === 'employees') {
        return;
      }
      toggleWeeklyCellSelection(event.data, colId);
      event.event.preventDefault();
    }

    function clearWeeklySelection() {
      selectedCells.value = [];
      cellSelected.value = [];
      selectAll = false;
      activeSelectionTool.value = '';
      weeklyGridApi.value?.refreshCells({ force: true });
    }

    function refreshWeeklyReviewRowsFromStore() {
      if (!weeklyReviewMode.value || registerView.value) {
        weeklyReviewRows.value = [];
        return;
      }
      const attendanceRows = store.getters['agGridModule/attendanceGridRows'] ?? [];
      weeklyReviewRows.value = buildWeeklyReviewRows(attendanceRows);
      weeklyReviewLoading.value = false;
      weeklyGridApi.value?.refreshCells({ force: true });
    }

    async function approveSelectedWeeklyRows() {
      const selectedCellsForTxn = filterSelectedCellsToWeeklyRange(selectedCells.value);
      if (selectedCellsForTxn.length === 0) {
        return;
      }
      weeklyReviewLoading.value = true;
      await approveAttendance(store, gridApi.value, selectedCellsForTxn, 'approve');
      clearWeeklySelection();
      refreshWeeklyReviewRowsFromStore();
    }

    async function rejectSelectedWeeklyRows() {
      const selectedCellsForTxn = filterSelectedCellsToWeeklyRange(selectedCells.value);
      if (selectedCellsForTxn.length === 0) {
        return;
      }
      weeklyReviewLoading.value = true;
      await rejectAttendance(store, gridApi.value, selectedCellsForTxn);
      clearWeeklySelection();
      refreshWeeklyReviewRowsFromStore();
    }

    async function unapproveSelectedWeeklyRows() {
      const selectedCellsForTxn = filterSelectedCellsToWeeklyRange(selectedCells.value);
      if (selectedCellsForTxn.length === 0) {
        return;
      }
      weeklyReviewLoading.value = true;
      await unapproveAttendance(store, gridApi.value, selectedCellsForTxn);
      clearWeeklySelection();
      refreshWeeklyReviewRowsFromStore();
    }

    async function saveWeeklyReviewSelection() {
      await save(store, registerView.value, gridApi.value);
    }

    function updateFilterValues(filterValue) {
      if (filterValue.type === 'contract') {
        filterValues.value.contract = filterValue.value;
        if (filterValues.value.contract !== null) {
          timeRange.value.day = filterValues.value.contract?.datePreviousMonth;
          let siteList = [];
          let shiftList = [];
          let productList = [];
          for (let i = 0; i < gridDataSource?.value?.contracts_id.length; i++) {
            if (gridDataSource?.value?.contracts_id?.[i]?.id === filterValues.value.contract?.id) {
              const filteredList = updateDataSource(gridDataSource?.value?.contracts_id?.[i], siteList, shiftList, productList);
              siteList = filteredList[0];
              shiftList = filteredList[1];
              productList = filteredList[2];
              break;
            }
          }
          gridDataSource.value['siteList'] = siteList;
          gridDataSource.value['shiftList'] = shiftList;
          gridDataSource.value['productList'] = productList;
        } else {
          timeRange.value.day = 1;
          let siteList = [];
          let shiftList = [];
          let productList = [];
          for (let i = 0; i < gridDataSource?.value?.contracts_id.length; i++) {
            const filteredList = updateDataSource(gridDataSource?.value?.contracts_id?.[i], siteList, shiftList, productList);
            siteList = filteredList[0];
            shiftList = filteredList[1];
            productList = filteredList[2];
          }
          gridDataSource.value['siteList'] = siteList;
          gridDataSource.value['shiftList'] = shiftList;
          gridDataSource.value['productList'] = productList;
        }
        setHeaderNames(JSON.parse(JSON.stringify(timeRange.value)), !(weeklyReviewMode.value && !registerView.value));
      } else  if (filterValue.type === 'site') {
        filterValues.value.site = filterValue.value;
      } else if (filterValue.type === 'shift') {
        filterValues.value.shift = filterValue.value;
      } else if (filterValue.type === 'designation') {
        filterValues.value.designation = filterValue.value;
      } else if (filterValue.type === 'department') {
        filterValues.value.department = filterValue.value;
      } else if (filterValue.type === 'attendanceType') {
        filterValues.value.attendanceType = filterValue.value;
      } else if (filterValue.type === 'reportingManager') {
        filterValues.value.reportingManger = filterValue.value;
      } else if (filterValue.type === 'employee') {
        if (filterValue.openRegisterView !== undefined) {
          if (filterValue.openRegisterView) {
            filterValues.value.employee = filterValue.value.id;
            showRegisterView(true);
            gridDataSource.value['employees'] = filterValue.value;
          }
        } else {
          filterValues.value.employee = filterValue.value;
        }
      }
      else if (filterValue?.[0]?.key === 'partners_id') {
        filterValues.value.partners_id = filterValue?.[0]?.value;
        filtersData();
      }
      if (weeklyReviewMode.value && !registerView.value && gridApi.value !== undefined && gridApi.value !== null) {
        weeklyReviewLoading.value = true;
        gridApi.value.refreshInfiniteCache();
      }
    }

    function addNewRow() {
      newRow = true;
      gridApi.value.refreshInfiniteCache();
    }

    function syncCellRendererParams() {
      if (gridApi.value === undefined || gridApi.value === null) {
        return;
      }
      const columnDefs = gridApi.value.getColumnDefs();
      for (let i = 0; i < columnDefs.length; i++) {
        if (columnDefs[i].field !== 'employees' && columnDefs[i].field !== 'total') {
          columnDefs[i].cellRendererParams = {
            'showSitesCellColor':showSitesCellColor,
            'showDesignationsCellColor':showDesignationsCellColor,
            'cellsSelected': selectedCells.value,
            'selectAllCells': selectAll,
            'activeSelectionTool' : activeSelectionTool,
            'isHideUnselected' : isHideUnselected
          }
        }
      }
      gridApi.value.setColumnDefs(columnDefs);
    }

    function clearSelection() {
      if (gridApi.value === undefined || gridApi.value === null) {
        return;
      }
      deselectAllCalled = true;
      selectedCells.value = [];
      cellSelected.value = [];
      selectAll = false;
      activeSelectionTool.value = '';
      const selected = gridApi.value.getSelectedNodes();
      for (let i = 0; i < selected.length; i++) {
        selected[i].setSelected(false);
      }
      syncCellRendererParams()
    }

    async function selectUnapproved(flag) {
      console.log('selectUnapproved ...')
      if (flag) {
        activeSelectionTool.value = 'unapproved'
        let result = await selectUnapprovedSetter(store, gridApi.value, registerView.value, timeRange.value);
        if (weeklyReviewMode.value) {
          result = filterSelectedCellsToWeeklyRange(result);
        }
        const hasSelection = Array.isArray(result) ? result.length > 0 : Object.keys(result ?? {}).length > 0;
        if (hasSelection) {
          selectedCells.value = result
          cellSelected.value = result
        } else {
          selectedCells.value = []
          cellSelected.value = []
        }
        syncCellRendererParams()
      }
      else {
        activeSelectionTool.value = ''
        selectedCells.value = []
        cellSelected.value = selectedCells.value
        syncCellRendererParams()
      }
      gridApi.value.refreshCells({ force: true })
      weeklyGridApi.value?.refreshCells({ force: true });
    }

    async function hideUnselected(flag) {
      console.log('hideUnselected ...')
      isHideUnselected.value = flag
      syncCellRendererParams()
      gridApi.value.refreshCells({ force: true })
      weeklyGridApi.value?.refreshCells({ force: true });
    }

    function showSites() {
      document.querySelector('.designations').checked = false;
      showDesignationsCellColor = false;
      const checkedValue = document.querySelector('.sites').checked;
      showSitesCellColor = checkedValue;
      toggleCellColor = true;
      syncCellRendererParams();
    }

    function showDesignations() {
      document.querySelector('.sites').checked = false;
      showSitesCellColor = false;
      const checkedValue = document.querySelector('.designations').checked;
      showDesignationsCellColor = checkedValue;
      toggleCellColor = true;
      syncCellRendererParams();
    }

    async function isApproveAttendance(isApprove, action) {
      const element = document.getElementsByClassName('alert-window');
      element[0].style.display = 'none';
      if (action != 'cancel') {
        const filteredData = await childRef.value?.filterSelectedCells(selectedCells.value);
        if (isApprove) {
          const cellsSelected = await approveAttendance(store, gridApi.value, filteredData, 'approve');
          console.log(cellsSelected);
        } else {
          const cellsSelected = await approveAttendance(store, gridApi.value, filteredData, 'settled');
          console.log(cellsSelected);
        }
      }
      clearSelection([]);
    }

    async function keyboardCommandsHandler(event) {
      if (event.altKey === true && event.keyCode === 73) {
        addNewRow(gridApi.value);
      }
      if (event.altKey === true && event.keyCode === 83) {
        await save(store, registerView.value, gridApi.value);
      }
      if (
        event.ctrlKey === true &&
        (event.keyCode === 65 || event.keyCode === 97)
      ) {
        gridApi.value.forEachNode((node) => {
          // Check if the row is already selected
          if (!selectedRows.includes(node.id)) {
            selectedRows.push(node.id);
            node.setSelected(true); // Select the row
            selectedRows = [];
          }
        });
      }
    }

    function normalizePastedNote(noteValue) {
      if (noteValue == null) {
        return null;
      }
      const normalized = String(noteValue).replace(/_USERREMARK_/g, '').trim();
      if (normalized.length === 0) {
        return null;
      }
      if (normalized.toLowerCase() === 'recorded attendance') {
        return null;
      }
      return normalized;
    }

    function resolvePastedNote(cellValue) {
      if (cellValue == null) {
        return null;
      }
      const directCandidates = [];
      directCandidates.push(cellValue?.attendance_edit?.notes);
      directCandidates.push(cellValue.notes);
      const attendanceData = cellValue.attendanceData ?? null;
      if (attendanceData != null) {
        directCandidates.push(attendanceData?.attendance_edit?.notes);
        directCandidates.push(attendanceData.notes);
      }

      for (let i = 0; i < directCandidates.length; i++) {
        const normalized = normalizePastedNote(directCandidates[i]);
        if (normalized != null) {
          return normalized;
        }
      }

      // Fallback only for explicit user remarks from historical text.
      const userRemarkCandidates = [];
      const exceptionList = Array.isArray(cellValue.exception) ? cellValue.exception : [];
      userRemarkCandidates.push(cellValue.remarks);
      userRemarkCandidates.push(cellValue?.latest_exception?.description);
      userRemarkCandidates.push(exceptionList.length > 0 ? exceptionList[exceptionList.length - 1]?.description : null);
      if (attendanceData != null) {
        const attendanceExceptionList = Array.isArray(attendanceData.exception) ? attendanceData.exception : [];
        userRemarkCandidates.push(attendanceData.remarks);
        userRemarkCandidates.push(attendanceData?.latest_exception?.description);
        userRemarkCandidates.push(attendanceExceptionList.length > 0 ? attendanceExceptionList[attendanceExceptionList.length - 1]?.description : null);
      }

      for (let i = 0; i < userRemarkCandidates.length; i++) {
        const candidate = userRemarkCandidates[i];
        if (candidate == null || !String(candidate).includes('_USERREMARK_')) {
          continue;
        }
        const normalized = normalizePastedNote(candidate);
        if (normalized != null) {
          return normalized;
        }
      }
      return null;
    }

    const onCellKeyDown = async(event) => {
      console.log('key event', event.colDef.field)
      if (event.event.code === 'Space') {
        const colId = event.column.colId;
        const selectedRowNode = event.node;
        const isSelected = selectedRowNode.isSelected();
        if (colId !== 'employees') {
          selectedRowNode.setSelected(!isSelected);
        }
        const result = await selectedCellsSetter(store, event, selectedCells.value, selectAll, registerView.value, timeRange.value);
        selectedCells.value = result.cellsSelected;
        selectAll = result.selectAllCells;
        cellSelected.value = result.cellsSelected;
      } else if (
        event.event.ctrlKey === true &&
        (event.event.keyCode === 65 || event.event.keyCode === 97) && event.colDef.field != 'employees'
      ) {
        const result = await selectedCellsSetter(store, event, selectedCells.value, selectAll, registerView.value, timeRange.value);
        selectedCells.value = result.cellsSelected;
        selectAll = result.selectAllCells;
        cellSelected.value = result.cellsSelected;
        if (!selectAll) {
          clearSelection([]);
        }
      } else if (event.event.ctrlKey === true && event.event.keyCode === 67 && event.colDef.field != 'employees') {
        if (!registerView.value) {
          if (event.value !== null && (event.value.leave_type === undefined || event.value.leave_type === null || event.value.leave_type.length === 0)) {
            copyValue = event.value
          } else {
            toast.warning('Leaves cannot be copied', {
              position: toast.POSITION.TOP_CENTER
            }
            );
          }
        } else {
          if (event.data !== null) {
            if (!event.data.isMissedPunch) {
              if (event.data['att_type'][0].code === 'L') {
                toast.warning('Leaves cannot be copied', {
                  position: toast.POSITION.TOP_CENTER
                }
                )
              } else {
                copyValue = event.data;
              }
            } else {
              toast.warning('Missed Punch cannot be copied', {
                position: toast.POSITION.TOP_CENTER
              }
              );
            }
          }
        }
      } else if (event.event.ctrlKey === true && event.event.keyCode === 86 && copyValue !== null && event.colDef.field != 'employees') {
        copyValue = JSON.parse(JSON.stringify(copyValue));
        copyTempValue = JSON.parse(JSON.stringify(copyValue));
        delete copyTempValue.attendance_edit;
        const pastedNote = resolvePastedNote(copyValue);
        //checking for refetched values
        for (const prop in event.value) {
          if (copyTempValue.hasOwnProperty(prop)) {
            if (prop != 'attendance_date' && JSON.stringify(event.value[prop]) === JSON.stringify(copyTempValue[prop])) {
              copyTempValue[prop] = null
            }
          }
        }
        if (registerView.value) {
          delete copyValue.attendanceData.attendance_status;
          delete copyValue.attendanceData.last_processed_by;
          delete copyValue.attendanceData.minWorkingHours;
          delete copyValue.attendanceData.exception;
          delete copyValue.attendanceData.allocations_id;
          delete copyValue.attendanceData.leave_type;
          delete copyValue.attendanceData.deficit_minutes;
          delete copyValue.attendanceData.uconst;
          delete copyValue.attendanceData.observed_in_tmstmp;
          delete copyValue.attendanceData.observed_out_tmstmp;
          delete copyValue.day;
          delete copyValue.dates;
          delete copyValue.dates;
          delete copyValue.remarks;
          delete copyValue.deficit_minutes;
          delete copyValue.backgroundColor;
          delete copyValue.attendance_status;
          delete copyValue.attendance_date;
          delete copyValue.observed_in_tmstmp;
          delete copyValue.observed_out_tmstmp;
          if (copyValue.attendance_edit !== undefined) {
            delete copyValue.attendanceEdit;
          }
          for (const key in copyValue) {
            event.data[key] = copyValue[key];
          }
          const newDate = getAttendanceDate(event, event.data.attendance_date);
          copyValue.attendanceData.id = uuidv4();
          copyValue.attendanceData['attendance_date'] = newDate;
          copyValue.attendanceData['sync_timestamp'] = newDate;
          if (pastedNote != null) {
            copyValue.attendanceData.notes = pastedNote;
            event.data.remarks = `_USERREMARK_${pastedNote}`;
          }
          const txnData = txnDataSetter(copyValue.attendanceData);
          await generateTxn(txnData);
          gridApi.value.refreshCells();
          return null;
        }
        const copiedCell = {[`${event.colDef.field}`] :  copyValue}
        const data = event.data;
        event.data = Object.assign(data, copiedCell)
        const newDate = getAttendanceDate(event, null);
        //if (copyTempValue.attendance_edit !== undefined && copyTempValue.attendance_edit !== null && event.value != null) {
        //  event.value = copyTempValue.attendance_edit;
        //  copyTempValue = copyTempValue.attendance_edit
        //} else {
        event.value = copyTempValue;
        copyTempValue['employees_id'] = event?.data?.employees;
        delete copyTempValue.attendance_status;
        delete copyTempValue.last_processed_by;
        delete copyTempValue.minWorkingHours;
        delete copyTempValue.exception;
        delete copyTempValue.allocations_id;
        delete copyTempValue.leave_type;
        delete copyTempValue.deficit_minutes;
        //if (copyTempValue.attendance_edit !== undefined) {
        //  delete copyTempValue.attendance_edit;
        //}
        //}
        copyTempValue.attendance_date = newDate
        copyTempValue['sync_timestamp'] = newDate
        copyTempValue.id = uuidv4()
        if (pastedNote != null) {
          copyTempValue.notes = pastedNote;
        } else {
          delete copyTempValue.notes;
        }
        delete copyTempValue.in_time;
        delete copyTempValue.out_time;
        //const txnData = txnDataSetter(copyValue);
        //await generateTxn(txnData);
        await store.dispatch('agGridModule/gridEditsSetter', JSON.parse(JSON.stringify(copyTempValue)));
        gridApi.value.refreshCells();
      } else if (event.event.shiftKey === true && (event.event.keyCode === 37 || event.event.keyCode === 38 || event.event.keyCode === 39 || event.event.keyCode === 40)) {
        const focusedCell = gridApi.value.getFocusedCell();
        if (!focusedCell) return;
        const column = focusedCell.column;
        const nextColumn = column;
        const colId = nextColumn.colId;
        if (colId === undefined || colId === 'employees' || colId === 'total') {
          return;
        }
        const value = event.data[colId]
        event.value = value;
        event.column = nextColumn;
        const result = await selectedCellsSetter(store, event, selectedCells.value, selectAll, registerView.value, timeRange.value);
        selectedCells.value = result.cellsSelected;
        selectAll = result.selectAllCells;
        cellSelected.value = result.cellsSelected;
        event.event.preventDefault();
      }
    };

    async function onCellClicked(event) {
      if (event.event.ctrlKey === true) {
        const colId = event.column.colId;
        const selectedRowNode = event.node;
        const isSelected = selectedRowNode.isSelected();
        if (colId === 'employees' || registerView.value) {
          selectedRowNode.setSelected(!isSelected);
        } else {
          selectedRowNode.setSelected(false);
        }
        const result = await selectedCellsSetter(store, event, selectedCells.value, selectAll, registerView.value, timeRange.value);
        if (result !== false) {
          selectedCells.value = result.cellsSelected;
          selectAll = result.selectAllCells;
          cellSelected.value = result.cellsSelected;
        } else {
          selectedRowNode.setSelected(false);
        }
      }
    }

    function addObjectIfUnique(array, newObject) {
      // Check if the object with the same id already exists in the array
      if (newObject !== undefined && newObject !== null) {
        const exists = array.some((obj) => obj.id === newObject?.id);
        // If it doesn't exist, push the new object to the array
        if (!exists) {
          array.push(newObject);
        }
      }
      return array;
    }

    function updateDataSource(contract, siteList, shiftList, productList) {
      if (contract?.attendance_based_items !== null) {
        for (let j = 0; j < contract?.attendance_based_items.length; j++) {
          siteList = addObjectIfUnique(siteList, contract?.attendance_based_items?.[j]?.sites_id?.[0])
          shiftList = addObjectIfUnique(shiftList, contract?.attendance_based_items?.[j]?.shifts_id?.[0])
          productList = addObjectIfUnique(productList, contract?.attendance_based_items?.[j]?.products_id?.[0])
        }
      } else if (contract?.job_based_items !== null) {
        for (let j = 0; j < contract?.job_based_items.length; j++) {
          siteList = addObjectIfUnique(siteList, contract?.job_based_items?.[j]?.sites_id?.[0])
          productList = addObjectIfUnique(productList, contract?.job_based_items?.[j]?.sites_id?.[0])
        }
        if (siteList.length > 0) {
          for (let k = 0; k < siteList.length; k++) {
            for (let l = 0; l < gridDataSource?.value?.shifts_id?.length; l++) {
              if (siteList?.[k]?.id === gridDataSource?.value?.shifts_id?.[l]?.sites_id?.[0]?.id) {
                shiftList = addObjectIfUnique(shiftList, gridDataSource?.value?.shifts_id?.[l])
              }
            }
          }
        }
      }
      return [siteList, shiftList, productList];
    }

    async function filtersData() {
      //using composables to get attendance_edits folder to set as bSettings
      const folderList = getFoldersFormList(bSettings);
      const currentFolder = getCurrentFolder('attendance_edits', folderList);
      const allocationsFolder = getCurrentFolder('allocations', folderList);
      const employeesFolder = getCurrentFolder('employees', folderList);
      const fieldNames = ['att_type', 'shifts_id', 'departments', 'subsections', 'sites_id', 'designation', 'attendance_edit_type'];
      const docpickerResults = await Promise.all(fieldNames.map((fieldName) =>
        getDocpickerList(fieldName !== 'departments' ? currentFolder?.fields?.[fieldName] : employeesFolder?.fields?.[fieldName])
      ));
      const contractsList = await getAllDocpickerList(allocationsFolder?.fields['contracts_id']);
      for (let i = 0; i < docpickerResults.length; i++) {
        const docpObj = docpickerResults[i];
        gridDataSource.value = Object.assign(gridDataSource.value, docpObj)
      }
      gridDataSource.value['contracts_id'] = contractsList?.['contracts_id'];
      console.log('FILTERSDATA')
      if (newRows.value !== null && newRows.value !== undefined) {
        if (newRows.value.length > 0) {
          if (newRows.value['employees'] !== undefined && newRows.value['employees'] !== null) {
            gridDataSource.value['employees'] = newRows.value['employees'];
          }
        }
      }
      // let siteList = [];
      // let shiftList = [];
      // let productList = [];
      // for (let i = 0; i < gridDataSource?.value?.contracts_id.length; i++) {
      //   const filteredList = updateDataSource(gridDataSource?.value?.contracts_id?.[i], siteList, shiftList, productList);
      //   siteList = filteredList[0];
      //   shiftList = filteredList[1];
      //   productList = filteredList[2];
      // }
      // gridDataSource.value['siteList'] = siteList;
      // gridDataSource.value['shiftList'] = shiftList;
      // gridDataSource.value['productList'] = productList;
      if (gridDataSource?.value?.['contracts_id']?.length === 1) {
        if (gridDataSource.value['contracts_id']?.[0]?.date_of_previous_month !== null) {
          timeRange.value.day = gridDataSource.value['contracts_id']?.[0]?.date_of_previous_month;
        }
      }
      setHeaderNames(timeRange.value, weeklyReviewMode.value && !registerView.value ? false : true)
      showLoader.value = false;
      if (newRows.value !== undefined) {
        if (newRows.value.length === 0) {
          gridApi.value.showNoRowsOverlay();
        }
      }
    }

    async function dataGenerator(params) {
      const isWeeklyReviewRequest = weeklyReviewMode.value && !registerView.value;
      const weeklyReviewRequestId = isWeeklyReviewRequest ? startWeeklyReviewRequest() : null;
      if (!isWeeklyReviewRequest) {
        cancelWeeklyReviewRequests();
      }
      try {
        console.time('test2');
        console.time('test3');
        let attendanceRows = store.getters['agGridModule/attendanceGridRows'];
        if (newRow) {
          attendanceRows.unshift({});
          totalRowCount.value = attendanceRows.length;
          newRow = false;
          setTimeout(() => {
            gridApi.value.setFocusedCell(0, gridApi.value?.columnModel?.columnDefs[0]?.field);
            gridApi.value.startEditingCell({
              rowIndex: 0,
              colKey: 'employees',
              keyPress: null,
              charPress: ''
            });
          }, 0);
        } else if (toggleCellColor) {
          toggleCellColor = false;
        } else {
          if (isEdited) {
            isEdited = false;
          }
          deselectAllCalled = false;
          const { dataCreation, attendanceList } = dataProcessor();
          const attendanceData = await attendanceList(params.filterModel, params, timeRange.value, currentFolder.value, filterValues.value, registerView.value);
          gridData.value = attendanceData.attendanceList;
          //store.state.attSummary = attendanceData.attendanceSummary;
          const idx = gridData.value.output?.data?.records[gridData.value.output?.data?.records.length - 1];
          if (idx?.dataStart !== idx?.dataEnd) {
            const rowCount = idx?.rowCount;
            totalRowCount.value = rowCount;
          }
          console.timeEnd('test2');
          const currFolder = getCurrentFolder('attendance', folderList);
          attendanceRows = await dataCreation(store, gridData.value, params.sortModel, attendanceData.attendanceSummary, attendanceData.attendanceTotalsSummary, registerView.value, timeRange.value, gridDataSource.value, filterValues.value.employee, fieldToSortEmployeeRows.value, orderToSortEmployeeRows.value, currFolder, filterValues.value);
          onGridReadyCalled.value = false;
          console.timeEnd('test3');
        }
        isEdited = false;
        if (isWeeklyReviewRequest) {
          if (isActiveWeeklyReviewRequest(weeklyReviewRequestId)) {
            weeklyReviewRows.value = buildWeeklyReviewRows(attendanceRows);
            weeklyReviewLoading.value = false;
          }
        } else {
          weeklyReviewRows.value = [];
        }
        syncCellRendererParams()
        return attendanceRows;
      } catch (err) {
        if (!isWeeklyReviewRequest || isActiveWeeklyReviewRequest(weeklyReviewRequestId)) {
          weeklyReviewLoading.value = false;
        }
        console.log(err);
      }
    }

    const onGridReady = (params) => {
      if (gridApi.value === undefined || gridApi.value === null) {
        gridApi.value = params?.api;
      }
      store.dispatch('agGridModule/attendanceGridApiSetter', gridApi.value);
      const dataSource = {
        rowCount: 200,
        getRows: async(params) => {
          try {
            console.log(
              'asking for ' + params.startRow + ' to ' + params.endRow
            );
            if (params.startRow === 0) {
              gridApi.value.showLoadingOverlay();
            }
            if (gridApi.value !== undefined && gridApi.value !== null) {
              gridApi.value.sizeColumnsToFit();
            }
            newRows.value = await dataGenerator(params);
            await store.dispatch(
              'agGridModule/attendanceGridRowsSetter',
              newRows.value
            );
            let lastRow = totalRowCount.value;
            if (registerView.value) {
              lastRow = newRows.value?.length;
            }
            if (newRows.value?.length === 0) {
              params.endRow = 0;
              lastRow = 0;
              if (showLoader.value === false) {
                gridApi.value.showNoRowsOverlay();
              }
            } else {
              params.endRow = newRows.value?.length;
              gridApi.value.hideOverlay();
            }
            params.successCallback(newRows.value, lastRow);
            gridApi.value.hideOverlay();
            if (!registerView.value) {
              gridApi.value.setPinnedBottomRowData([{}]);
            }
            if (registerView.value && filterValues.value.employee === null) {
              if (newRows.value !== null && newRows.value !== undefined) {
                if (newRows.value.length > 0) {
                  if (newRows.value['employees'] !== undefined && newRows.value['employees'] !== null) {
                    gridDataSource.value['employees'] = newRows.value['employees'];
                  }
                }
              }
            }
          } catch (err) {
            console.error('Error loading data:', err);
            toast.error(err, {
              position: toast.POSITION.TOP_CENTER
            });
            params.failCallback();
          }
        },
      };
      if (params !== undefined) {
        params?.api?.setDatasource(dataSource);
        filtersData();
        setChecksForEdits(timeRange.value)
      } else {
        gridApi.value?.setDatasource(dataSource);
        gridApi.value?.sizeColumnsToFit();

      }
    };

    function setHeaderNames(monthYear, shouldRefreshData = true) {
      if (!registerView.value) {
        const monthGroupColumnsDefs = attendancePeriodColumns(monthYear, gridDataSource.value, showSitesCellColor, showDesignationsCellColor, isEditedEnable, selectedCells.value, selectAll, showInOut, activeSelectionTool.value, isHideUnselected.value);
        // const newColumnDefs = gridApi.value.getColumnDefs()
        const newColumnDefs = gridColumnDefs;
        const columnsArray = [];
        columnsArray.push(newColumnDefs[0]);
        columnsArray.push(...monthGroupColumnsDefs);
        columnsArray.push(newColumnDefs[newColumnDefs.length - 1]);
        columnDefs.value = columnsArray;
      } else {
        columnDefs.value = registerViewColumnDefs;
      }
      if (shouldRefreshData && gridApi.value !== undefined && gridApi.value !== null) {
        gridApi.value.refreshInfiniteCache();
      }
    }

    function updateMonthYear(newMonthYear) {
      timeRange.value = newMonthYear;

    }

    //watchers
    watch(() => timeRange.value,
      async(newTimeRange, oldTimeRange) => {
        if (
          newTimeRange.year !== oldTimeRange.year ||
          newTimeRange.month !== new Date(`${oldTimeRange.month} 1, 2000`).getMonth() + 1
        ) {
          selectedWeekStart.value = clampWeekStartToSelectedMonth(selectedWeekStart.value);
          syncWeeklyFilterState();
          weeklyReviewLoading.value = weeklyReviewMode.value;
          totalRowCount.value = 0;
          if (weeklyReviewMode.value && !registerView.value && gridApi.value) {
            gridApi.value.refreshInfiniteCache();
          } else if (gridApi.value?.infiniteRowModel) {
            gridApi.value.infiniteRowModel.resetCache();
          }
          setHeaderNames(
            JSON.parse(JSON.stringify(newTimeRange)),
            weeklyReviewMode.value && !registerView.value ? false : true
          );
          setChecksForEdits(newTimeRange)
        }
      }
    );

    //lifecycle hooks
    onBeforeMount(async() => {
      syncWeeklyFilterState();
      rowBuffer.value = 0;
      rowModelType.value = 'infinite';
      rowSelection.value = 'multiple';
      cacheBlockSize.value = 100;
      cacheOverflowSize.value = 2;
      maxConcurrentDatasourceRequests.value = 1;
      infiniteInitialRowCount.value = 0;
      maxBlocksInCache.value = 50;
      pinnedBottomRowData.value = !registerView.value ? [0] : null;
      showLoader.value = true;
      suppressRowSelection.value = true;
      suppressRowClickSelection.value = true;
      stopEditingWhenGridLosesFocus.value = true;
      loadingOverlayComponent.value = WfmLoader;
      loadingOverlayComponentParams.value = {isRegisterView: registerView.value}
    });

    return {
      currentFolder,
      registerView,
      canViewWeeklyReview,
      weeklyReviewMode,
      selectedWeekStart,
      weeklyRangeDisplay,
      weekPickerMinDate,
      weekPickerMaxDate,
      canGoToPreviousWeek,
      canGoToNextWeek,
      onWeeklyReviewModeToggle,
      onWeeklyRangeChange,
      goToPreviousWeek,
      goToNextWeek,
      goToCurrentWeek,
      showRegisterView,
      selectedCells,
      updateMonthYear,
      showInOutTimeToggle,
      cellSelected,
      clearSelection,
      updateFilterValues,
      onCellKeyDown,
      onCellClicked,
      showLoader,
      weeklyReviewLoading,
      columnDefs,
      weeklyReviewRows,
      weeklyReviewColumnDefs,
      defaultColDefWeeklyReview,
      onWeeklyGridReady,
      onWeeklyCellClicked,
      onWeeklyCellKeyDown,
      weeklyGridHeight,
      weeklyRowHeight,
      isHideUnselected,
      gridApi,
      gridHeight,
      rowHeight,
      headerHeight,
      rowBuffer,
      rowSelection,
      suppressRowSelection,
      suppressRowClickSelection,
      stopEditingWhenGridLosesFocus,
      rowModelType,
      cacheBlockSize,
      cacheOverflowSize,
      maxConcurrentDatasourceRequests,
      loadingOverlayComponent,
      loadingOverlayComponentParams,
      infiniteInitialRowCount,
      maxBlocksInCache,
      keyboardCommandsHandler,
      onGridReady,
      timeRange,
      pinnedBottomRowData,
      calendarParams,
      formFolder,
      txnForCalendar,
      formOpen,
      closeCalendar,
      currEmpAttData,
      updateKeepAliveState,
      gridDataSource,
      showSites,
      showDesignations,
      selectUnapproved,
      clearWeeklySelection,
      approveSelectedWeeklyRows,
      rejectSelectedWeeklyRows,
      unapproveSelectedWeeklyRows,
      saveWeeklyReviewSelection,
      hideUnselected,
      tabKey,
      tabsList,
      selectedIndex,
      addTab,
      changeTab,
      delTab,
      customTabsClass,
      isApproveAttendance,
      defaultColDefRegister,
      defaultColDefAttendance,
      onModelUpdated,
      isRenderComplete,
      childRef
    };
  },
};
</script>
<style>

.grid-container {
  padding: 2px;
  border: 1px solid #83ACC8;
  display: flex;
  flex-direction: column;
}
.calendar-modal{
  z-index: 1000 !important;
}

.attendance-view {
  position: relative;
}

.attendance-loader-shell {
  position: fixed;
  inset: 0;
  z-index: 110;
  background: #ffffff;
}

.weekly-review-loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 110;
  background: rgba(255, 255, 255, 0.08);
  pointer-events: none;
}

#attendance-grid,
#my-grid,
#weekly-review-grid {
  width: 100%;
  z-index:1
}

.ag-theme-quartz .ag-row-selected {
  border: 1px solid #00b7ff !important;
}

.ag-header-cell-menu-button {
  opacity: 1 !important;
}
.register-ag-grid .ag-cell-value, .ag-cell {
  overflow: hidden !important;
}
.ag-header-group-cell-label, .ag-header-cell-label {
  justify-content: center !important;
}
:deep .ag-root-wrapper {
  overflow: visible;
}

.ag-theme-quartz {
  --ag-foreground-color: black;
  --ag-background-color: #ffffff;
  --ag-header-foreground-color: var(--main-background-color);
  --ag-header-background-color: #83ACC8;
  --ag-font-size: 12px;
  --ag-overlay-background-color: var(--main-background-color) !important;
  --ag-selected-row-background-color: rgba(0, 102, 255, 0.1);
  --ag-font-family: 'Poppins', sans-serif;
  --ag-popup-shadow: black;
  --ag-borders: none;
  --ag-row-border-style: solid;
  --ag-row-border-width: 0.1px;
  --ag-row-border-color: #aebbcc;
  --ag-header-column-resize-handle-display: inline;
  --ag-icon-font-family: "agGridAlpine";
  --ag-icon-size: 16px;
}

.month-switcher {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-shrink: 0;
  z-index: 10;
}

.weekly-review-grid {
  width: 100%;
  --ag-background-color: #f6f8fb;
  --ag-selected-row-background-color: rgba(94, 128, 168, 0.18);
  --ag-row-border-color: #d5dde8;
  --ag-header-background-color: #7ea2bb;
  --ag-header-foreground-color: #112433;
}

.weekly-review-grid :deep(.ag-root-wrapper) {
  background: linear-gradient(180deg, #f7f9fc 0%, #eef3f8 100%);
}

.weekly-review-grid :deep(.ag-header) {
  border-bottom: 1px solid #c7d2df;
}

.weekly-review-grid :deep(.ag-cell) {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

.alert-window {
  color: #292929;
  font-size: 20px;
  display: none;
  position: absolute;
  bottom: 0%;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  backdrop-filter: blur(5px)!important;
}

.alert-content {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  position: relative;
  top: 20%;
  left: 30%;
  width: 611px;
  height: 450px;
  background-color: rgb(236 236 236);
  border-radius: 10px;
}

.alert-note {
  font-size: 15px;
  padding: 15px;
  text-align:left;
}

.alert-buttons {
  width: 200px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.alert-buttons button {
  background-color: #aebbcc;
  padding: 5px;
  border-radius: 5px;
  margin: 2px;
}

.alert-buttons button:hover {
  background-color: #83ACC8;
}

.ag-body-viewport {
    overflow-y: scroll !important;
}
</style>
